import { RawDataResponse } from "../hooks/useRaw"

// const paramsOrder = ["Particulate", "SOx", "NOx", "O2", "Opacity", "CO", "CO2"].reverse()
const paramsOrder = ["pH", "COD","TSS", "NH3N", "Debit"].reverse()
export const CORRECTED = ["COD", "TSS"]

const distinctSensor = (data: RawDataResponse) =>
  data
    ?.map((company) =>
      company.mils
        ?.map((mils) => mils.cems?.map((cem) => cem.parameters)?.reduce((a, b) => a.concat(b), []))
        ?.reduce((a, b) => a.concat(b), [])
    )
    ?.reduce((a, b) => a.concat(b), [])
    ?.filter((value, index, self) => {
      return self.map(({ name }) => name).indexOf(value.name) === index
    })

    // .sort((a, b) => a.name.localeCompare(b.name))
    .sort((a, b) => paramsSort(a.name, b.name))

export const paramsSort = (a: string, b: string) => paramsOrder.indexOf(b) - paramsOrder.indexOf(a)

export default distinctSensor
